import {headerDesktopSpacing, headerMobileSpacing} from "../../@signals";


export const maximalLayoutMainMobileStyles = () => ({
    flexGrow: 1,
    pl: "22px",
    pr: "16px",
    pt: `${headerMobileSpacing.value}px`,
    pb: `${headerMobileSpacing.value}px`,
    minHeight: "95vh"
})

export const maximalLayoutMainDesktopStyles = () => ({
    ...maximalLayoutMainMobileStyles(),
    pt: `${headerDesktopSpacing.value}px`,
    pb: `${headerDesktopSpacing.value}px`,
    width: "calc(100% - 280px)"
})